<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.documentIdentificator.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.documentIdentificator.description') }}
    </p>

    <div v-if="isLoading">
      <div class="w-full mt-3 flex">
        <div class="loader loader--circle animation--wave bg-zt-dark-200 mr-3"></div>
        <div class="group-line">
          <div class="loader loader--line animation--wave bg-zt-dark-200 mb-1"></div>
          <div class="loader loader--line animation--wave bg-zt-dark-200"></div>
        </div>
      </div>

      <div class="w-full mt-3 flex">
        <div class="loader loader--circle animation--wave bg-zt-dark-200 mr-3"></div>
        <div class="group-line">
          <div class="loader loader--line animation--wave bg-zt-dark-200 mb-1"></div>
          <div class="loader loader--line animation--wave bg-zt-dark-200"></div>
        </div>
      </div>
    </div>
    <div
      v-else
      v-for="(parser, index) in list"
      :key="index"
      class="w-full radio-group"
    >
      <zt-radio-button
        :value="parser.parser"
        v-model="selected"
        name="method"
        @change="update"
        data-vs-radio-button="documentIdentificator"
      >
        <span class="custom-label">{{ parser.alias }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ parser.description }}
      </span>
    </div>
  </div>
</template>
<script>
import { find } from 'lodash'
export default {
  name: 'SubFolderDocumentIdentificator',
  inject: ['stateFolder', 'setSubFolderParams'],
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: ''
    }
  },
  computed: {
    isLoading() {
      return this.list.length === 0
    }
  },
  watch: {
    list() {
      if (!this.isLoading && this.list.length) {
        const parser = this.stateFolder.subFolderParams.parser
        const inParserList = find(this.list, { parser })
        this.selected = inParserList ? parser : this.list[this.list.length-1].parser
      }
    }
  },
  methods: {
    update() {
      this.setSubFolderParams({
        parser: this.selected
      })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
.loader {
  width: fit-content;
  cursor: wait;
}
.loader--circle {
  overflow: hidden;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 60px;
    height: 24px;
  }
}
.group-line {
  width: calc(100% - 24px);
  position: relative;
}
.loader--line {
  overflow: hidden;
  width: 100%;
  height: 20px;
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 120%;
    height: 24px;
  }
}
.animation--wave::before {
  background: linear-gradient(115deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: wave 1.5s linear .5s infinite;
}
@keyframes wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

::v-deep {
  .zt-input-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>